import type { FaireProductEntity } from "../../entity_types/product";

export const p_4tat7nvaph: FaireProductEntity = {
  token: "p_4tat7nvaph",
  type: "product",
  name: "Colorful Enamel Evil Eye Adjustable Ring, 18K Gold Filled Ev",
  brandToken: "b_4f46qpq5wu",
  brandName: "BestBeads&Beyond",
  imageUrl:
    "https://cdn.faire.com/fastly/d15b7af800d37a174d6248edbb6bf176f88112b76fabc70d7189d88a4f5defc3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53873cc25e0ab8d7ddddf6622ec7d969675f8a5a3a73c4f96111b11b6a5bdb6b.png",
    "https://cdn.faire.com/fastly/0c97c866efa610e6aef3aa29bf8d834c5ff02d38a60b07e7b02d8768b2f19239.png",
    "https://cdn.faire.com/fastly/584a77c9f5e8cec64eabdc0db38bdb7ce326625c3c4970af8cee27e1d7461cdc.png",
  ],
  priceDollars: 8.3,
  description:
    "Qty:1pc pack\nMaterial: Brass and Enamel, Gold Filled\n Size:6.8x21.4mm\n\nDescription: 18K Gold Filled over Copper, Colorful Enamel Evil Eye\n\nUsage: Gold Filled findings have a precious metal look. \n--------------------------------------------------\nShip from the U.S.A in 1-2 business days.\n\n* Lead-Free & Cadmium Free & Nickel Free* \n\n*All sizes are approximate\n\n***Please Conv. me if you need quantity discount. Y581",
  tags: [],
  msrpDollars: 16.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:56.277Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
